<header>
  <div class="logo-header">
    <img
      src="assets/images/cbw-logo.png"
      alt="Camp Bow Wow logo"
      class="logo"
    >
  </div>
</header>
<div
  class="reg-body"
  role="main"
>
  <router-outlet></router-outlet>
  <app-privacy-policy-footer></app-privacy-policy-footer>
</div>